

<h3 *ngIf="isComparing" mat-dialog-title class="title-layout">Comparing Yamazumi and Standardized Work</h3>
<h3 *ngIf="isComplete" mat-dialog-title class="title-layout">Standardized Work is updated.</h3>
<h3 *ngIf="noChange" mat-dialog-title class="title-layout">No changes between Yamazumi and Standardized Work were found.</h3>
<button *ngIf="noChange" mat-button (click)="onNoClick()">Cancel</button>
<h3 *ngIf="!isComparing && !isComplete && !noChange" mat-dialog-title class="title-layout">Update Standardized Work</h3>

<div *ngIf="!isComparing && !isComplete && !noChange" mat-dialog-content>
    
    <p>The following pitch variants have changed. On Submit, existing Standardized Work will be deleted and work elements will be updated with the new descriptions and order.</p>

    <table mat-table [dataSource]="pitchVariantList" class="mat-elevation-z0">
        <ng-container matColumnDef="pitch_id">
            <th mat-header-cell *matHeaderCellDef> Pitch ID </th>
            <td mat-cell *matCellDef="let element"> {{element.pitch_id}}</td>
        </ng-container>

        <ng-container matColumnDef="subassembly_id">
            <th mat-header-cell *matHeaderCellDef> Subassembly ID </th>
            <td mat-cell *matCellDef="let element"> <span *ngIf="element.subassembly_id">({{element.subassembly_id}})</span></td>
        </ng-container>

        <ng-container matColumnDef="pitch_name">
            <th mat-header-cell *matHeaderCellDef> Pitch Name </th>
            <td mat-cell *matCellDef="let element"> {{element.pitch_name}}</td>
        </ng-container>

        <ng-container matColumnDef="variant_name">
            <th mat-header-cell *matHeaderCellDef> Variant </th>
            <td mat-cell *matCellDef="let element"> {{element.variant_name}}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <br>
  

    <div mat-dialog-actions>
        <button mat-button color="primary" (click)="onSubmit()">Submit</button>
        <button mat-button (click)="onNoClick()">Cancel</button>
    </div>
</div>

<div *ngIf="isComparing || isUpdating">
    <mat-spinner></mat-spinner>
</div>

